import * as React from 'react';
import { Row } from '../Row';
import { useSelector } from 'react-redux';
import { selectTotalAmount } from '../../../../selectors/checkoutInfo';
import { getTotalValue } from './utils';

export const TotalAmountContainer = () => {
  const totalPrice = useSelector(selectTotalAmount);

  if (!totalPrice.price && !totalPrice.auctionPoints) {
    return null;
  }

  const priceValue = getTotalValue(totalPrice);

  return <Row isTotal name="Сейчас к оплате" value={priceValue} />;
};
